// extracted by mini-css-extract-plugin
module.exports = {"dataDeEntrega":"manutencao_dataDeEntrega__2WmMU"};